/*
  Reading progress tracker for /pages/the-word.
  Phase 1: localStorage only (per-browser).
  Phase 2 (v2): the `subscribe` hook is where an App Proxy sync layer
  will plug in to mirror state to customer.metafields.utc.reading_progress
  when the customer is signed in.
*/
(function () {
  'use strict';

  var STORAGE_KEY = 'utc_reading_progress_v1';
  var listeners = [];

  function todayKey() {
    var d = new Date();
    return d.getFullYear() + '-' +
           String(d.getMonth() + 1).padStart(2, '0') + '-' +
           String(d.getDate()).padStart(2, '0');
  }

  function defaults() {
    return {
      version: 1,
      lastSpread: 0,
      lastChapterRef: null,   /* { book, chapter } */
      chapters: {},           /* "Book|N" → first-seen ISO date */
      activityDays: {}        /* ISO date → count of NEW chapters that day */
    };
  }

  function load() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return defaults();
      var data = JSON.parse(raw);
      if (!data || data.version !== 1) return defaults();
      /* defensive shape */
      if (typeof data.lastSpread !== 'number') data.lastSpread = 0;
      if (!data.chapters || typeof data.chapters !== 'object') data.chapters = {};
      if (!data.activityDays || typeof data.activityDays !== 'object') data.activityDays = {};
      return data;
    } catch (e) {
      return defaults();
    }
  }

  function save(data) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch (e) {}
    listeners.forEach(function (fn) { try { fn(data); } catch (_) {} });
  }

  function recordChapter(book, chapter) {
    if (!book || !chapter) return null;
    var data = load();
    var key = book + '|' + chapter;
    var isNew = !data.chapters[key];
    data.chapters[key] = todayKey();
    data.lastChapterRef = { book: book, chapter: chapter };
    if (isNew) {
      data.activityDays[todayKey()] = (data.activityDays[todayKey()] || 0) + 1;
    }
    save(data);
    return data;
  }

  function recordSpread(spread, book, chapter) {
    var data = load();
    data.lastSpread = spread;
    if (book && chapter) data.lastChapterRef = { book: book, chapter: chapter };
    save(data);
    return data;
  }

  /* ─── Derived stats ──────────────────────────── */

  function chaptersThisMonth(data) {
    var now = new Date();
    var ym = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0');
    var n = 0;
    Object.keys(data.chapters).forEach(function (k) {
      if (String(data.chapters[k]).indexOf(ym) === 0) n++;
    });
    return n;
  }

  function streakDays(data) {
    var keys = Object.keys(data.activityDays);
    if (!keys.length) return 0;
    /* Walk backwards from today. Allow a 1-day grace if today has no reading yet. */
    var d = new Date();
    var streak = 0;
    var graceUsed = false;
    for (var i = 0; i < 366; i++) {
      var k = d.getFullYear() + '-' +
              String(d.getMonth() + 1).padStart(2, '0') + '-' +
              String(d.getDate()).padStart(2, '0');
      if (data.activityDays[k]) {
        streak++;
      } else if (i === 0 && !graceUsed) {
        graceUsed = true;  /* skip today if no reading yet */
      } else {
        break;
      }
      d.setDate(d.getDate() - 1);
    }
    return streak;
  }

  function bookCompletion(data, catalog) {
    var out = {};
    Object.keys(catalog).forEach(function (book) {
      var chapters = catalog[book];
      var total = chapters.length;
      var read = 0;
      chapters.forEach(function (ch) {
        if (data.chapters[book + '|' + ch]) read++;
      });
      out[book] = {
        read: read,
        total: total,
        pct: total ? Math.round(read * 100 / total) : 0,
        complete: total > 0 && read === total
      };
    });
    return out;
  }

  function booksCompleted(data, catalog) {
    var n = 0;
    var bc = bookCompletion(data, catalog);
    Object.keys(bc).forEach(function (b) { if (bc[b].complete) n++; });
    return n;
  }

  /* ─── Sync hook (v2: App Proxy plug-in point) ── */
  function subscribe(fn) {
    if (typeof fn === 'function') listeners.push(fn);
    return function unsubscribe() {
      listeners = listeners.filter(function (x) { return x !== fn; });
    };
  }

  window.UTC_ReadingProgress = {
    STORAGE_KEY: STORAGE_KEY,
    load: load,
    recordChapter: recordChapter,
    recordSpread: recordSpread,
    chaptersThisMonth: chaptersThisMonth,
    streakDays: streakDays,
    bookCompletion: bookCompletion,
    booksCompleted: booksCompleted,
    subscribe: subscribe
  };
})();
